// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreQuoteThresholds = (client) => ({
    /**
     * `GET /store/quote-thresholds`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListQuoteThresholds
     * @source packages/medusa-plugin-moq-v2/src/api/store/quote-thresholds/route.ts
     */
    list: (query, headers) => client.fetch("/store/quote-thresholds", { method: "GET", query, headers }),
});
//# sourceMappingURL=quote-thresholds.js.map